import * as React from "react";
function SvgIconPaperairplaneW(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 16.229" {...props}><g data-name="icon_paper airplane_w" fill="#fff"><path data-name="\u30D1\u30B9 38" d="M4.754 16.229l3.5-2.7-3.5-2.378z" /><path data-name="\u30D1\u30B9 39" d="M0 6.557l4.8 3.482 13.395-8.563-12.235 9.4 7.152 5.185L20 0z" /></g></svg>;
}
export default SvgIconPaperairplaneW;